module.exports = __webpack_public_path__ + "components/carousel-photo-gallery/static/generic-bg--7-976e3392c7d64d25c31bf40e35ee8e14.jpg";